import send from '../../utils/fetch'
import { nameToSlug } from '../../utils/utils'

const actions = {
    async GET_ALL_LANDINGS({ commit, getters }, type = true) {
        try {
            let response
            if (type) {
                response = await send(global.$url.settings_landings.get, 'GET')
                    .then(response => response.data.result)

                commit('SET_LANDINGS', {...response, offers: getters.offers} )
            } else {
                response = await send(global.$url.landings.get, 'GET')
                    .then(response => response.data.result)
                commit('SET_COMMON_LANDINGS', response )
            }
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_STATUS_LANDINGS({ dispatch }, { id }) {
        try {
            const {data} = await send(global.$url.settings_landings.destroy, 'DELETE', {data: {id}})
            await dispatch('GET_ALL_LANDINGS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async CREATE_LANDING({ dispatch }, landing) {
        try {
            landing.slug = nameToSlug(landing.name)
            delete landing.id
            const {data} = await send(global.$url.settings_landings.create, 'POST', {data: landing})
            await dispatch('GET_ALL_LANDINGS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_LANDING({ dispatch }, landing) {
        try {
            landing.slug = nameToSlug(landing.name)
            const {data} = await send(global.$url.settings_landings.update, 'PUT', {data: landing})
            await dispatch('GET_ALL_LANDINGS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async CHECK_LANDING_URL({ commit }, url) {
        try {
            const {data} = await send(global.$url.settings_landings.check, 'POST', {data: url})
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

export default actions
